import script from "./TopNavMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNavMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TopNavMenu.vue?vue&type=style&index=0&id=eecef9b2&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eecef9b2"]])

export default __exports__